export var StepIndexSMART;
(function (StepIndexSMART) {
    StepIndexSMART[StepIndexSMART["first"] = 1] = "first";
    StepIndexSMART[StepIndexSMART["second"] = 2] = "second";
    StepIndexSMART[StepIndexSMART["third"] = 3] = "third";
    StepIndexSMART[StepIndexSMART["fourth"] = 4] = "fourth";
    StepIndexSMART[StepIndexSMART["fifth"] = 5] = "fifth";
    StepIndexSMART[StepIndexSMART["sixth"] = 6] = "sixth";
    StepIndexSMART[StepIndexSMART["seventh"] = 7] = "seventh";
    StepIndexSMART[StepIndexSMART["eighth"] = 8] = "eighth";
    StepIndexSMART[StepIndexSMART["ninth"] = 9] = "ninth";
})(StepIndexSMART || (StepIndexSMART = {}));
export var StepIndexZota;
(function (StepIndexZota) {
    StepIndexZota[StepIndexZota["first"] = 1] = "first";
    StepIndexZota[StepIndexZota["second"] = 2] = "second";
    StepIndexZota[StepIndexZota["third"] = 3] = "third";
    StepIndexZota[StepIndexZota["fourth"] = 4] = "fourth";
    StepIndexZota[StepIndexZota["fifth"] = 5] = "fifth";
    StepIndexZota[StepIndexZota["sixth"] = 6] = "sixth";
    StepIndexZota[StepIndexZota["seventh"] = 7] = "seventh";
    StepIndexZota[StepIndexZota["eighth"] = 8] = "eighth";
    StepIndexZota[StepIndexZota["ninth"] = 9] = "ninth";
})(StepIndexZota || (StepIndexZota = {}));
export var SettingsMasterStep;
(function (SettingsMasterStep) {
    SettingsMasterStep["DigitalBus"] = "DigitalBus";
    SettingsMasterStep["Relay"] = "Relay";
    SettingsMasterStep["GasBoiler"] = "GasBoiler";
    SettingsMasterStep["ElectricalBoiler"] = "ElectricalBoiler";
    SettingsMasterStep["BoilerDHW"] = "BoilerDHW";
    SettingsMasterStep["BoilerNoDHW"] = "BoilerNoDHW";
    SettingsMasterStep["SingleCircuit"] = "SingleCircuit";
    SettingsMasterStep["DoubleCircuit"] = "DoubleCircuit";
    SettingsMasterStep["AirControl"] = "AirControl";
    SettingsMasterStep["WaterControl"] = "WaterControl";
    SettingsMasterStep["PZAControl"] = "PZAControl";
    SettingsMasterStep["WithoutPIDRegulation"] = "WithoutPIDRegulation";
    SettingsMasterStep["WithPIDRegulation"] = "WithPIDRegulation";
    SettingsMasterStep["InRoomTemp"] = "InRoomTemp";
    SettingsMasterStep["OutRoomTemp"] = "OutRoomTemp";
    SettingsMasterStep["SavedSetting"] = "SavedSetting";
    SettingsMasterStep["NoSavedSetting"] = "NoSavedSetting";
    SettingsMasterStep["BoilerModel"] = "BoilerModel";
})(SettingsMasterStep || (SettingsMasterStep = {}));
